import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { isMobile } from "react-device-detect";
import Spacebox from "../components/Spacebox";
import Grid from "../components/Grid";

const Terms = ({ title }) => {

    document.querySelector('title').innerHTMl = title

    const terms_info = [
        {
            image: '/svgs/terms.svg',
            heading: 'Service Terms',
            content: 'Clear guidelines about our funding services and responsibilities.'
        },
        {
            image: '/svgs/duration.svg',
            heading: 'Service Duration',
            content: `Terms regarding service duration and renewal conditions.`
        },
        {
            image: '/svgs/security.svg',
            heading: 'User Obligations',
            content: `Your responsibilities while using our services.`
        },
        {
            image: '/svgs/partnership.svg',
            heading: 'Account Usage',
            content: `Guidelines for account creation and management.`
        },
        {
            image: '/svgs/disclaimer.svg',
            heading: 'Disclaimers',
            content: `Important information about service limitations.`
        },
        {
            image: '/svgs/file.svg',
            heading: 'Documentation',
            content: `Required documentation and verification processes.`
        },

    ]

    const terms_lists = [
        {
            heading: 'Service Description',
            sub: 'Our services include:',
            lists: [
                'Business funding solutions and advisory',
                'Financial assessment and recommendations',
                'Funding application processing',
                'Ongoing support and consultation'
            ]
        },
        {
            heading: 'User Responsibilities',
            sub: 'As a user, you agree to:',
            lists: [
                'Provide accurate and truthful information',
                'Maintain the security of your account',
                'Comply with all applicable laws and regulations',
                'Use our services in good faith'
            ]
        },
        {
            heading: 'Service Limitations',
            sub: 'Please note the following limitations:',
            lists: [
                'Funding approval is not guaranteed',
                'Terms and rates may vary based on assessment',
                'Service availability may be subject to change',
                'Some features may require additional verification'
            ]
        },
        {
            heading: 'Modifications',
            sub: 'We reserve the right to:',
            lists: [
                'Modify these terms at any time',
                'Update service features and functionality',
                'Adjust pricing and fee structures',
                'Change eligibility requirements'
            ]
        },
    ]



    return (
        <div className="about-page">
            <Header />
            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Flexbox justifyContent="center" alignItems="center">
                            <Flexbox alignItems="center" justifyContent="center" style={{ width: '30px', height: 30, padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '100px' }}>
                                <img src="/svgs/file.svg" alt="file" />
                            </Flexbox>
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '40px' : '60px', color: 'var(--primary)' }}>
                            Terms of Service
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ textAlign: 'center', color: '#00000060', fontSize: isMobile ? '18px' : '20px' }}>
                            Please read these terms carefully before using FundGenies's services.
                        </Typography>
                        <Spacebox padding="10px" />
                        <Grid grid={isMobile ? 1 : 3} gap="20px">
                            {terms_info.map((a, i) => (
                                <div key={i} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                    <Flexbox alignItems="center" justifyContent="center" style={{ display: 'inline-block', padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '5px' }}>
                                        <img src={a.image} alt={a.heading} style={{ width: '30px' }} />
                                    </Flexbox>
                                    <Spacebox padding="10px" />
                                    <Typography>
                                        <b>
                                            {a.heading}
                                        </b>
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <span className="content" style={{ opacity: .6 }}>
                                        {a.content}
                                    </span>
                                </div>
                            ))}
                        </Grid>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>
            <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div>
                        <Spacebox padding="10px" />
                        <Container>
                            <Typography variant="h4" style={{ fontSize: isMobile ? '25px' : '30px' }}>
                                Terms and Conditions
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, fontSize: '18px' }}>
                                By accessing and using BrightStarr's services, you agree to comply with and be bound by these terms and conditions.
                            </Typography>
                            <Spacebox padding="20px" />
                            {terms_lists.map((list, i) => (
                                <div key={i} style={{ marginBottom: '20px' }}>
                                    <Typography style={{ fontSize: '18px', fontWeight: '700' }}>
                                        {list.heading}
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <span style={{ opacity: .6 }}>
                                        {list.sub}
                                    </span>
                                    <ul>
                                        {list.lists.map((l, x) => (
                                            <li key={x} style={{ opacity: .6 }}>
                                                {l}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                            <Spacebox padding="20px" />
                            <div style={{borderRadius: '10px', background: '#4A3FFF20', padding: '30px 10px'}}>
                                <small style={{opacity: .6}}>
                                    Last updated: {((new Date(Date.now())).toString().substring(4, 16))}
                                </small>
                            </div>
                        </Container>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>
            <Footer />
        </div>
    );
}

export default Terms;